import dynamic from 'next/dynamic'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import LazyLoad from 'react-lazyload'
import ContactRequestButton from '~/components/LandingPage/components/ContactRequestButton'
import FeatureBlock from '~/components/LandingPage/components/FeatureBlock/FeatureBlock'
import HeroBanner from '~/components/LandingPage/HeroBanner'
import JourneySection from '~/components/LandingPage/JourneySection'
import TeamSection from '~/components/LandingPage/TeamSection'
import LayoutLandingPage from '~/components/Layout/LayoutLandingPage'

const LazyLoadWrapper = LazyLoad as unknown as FC<any>

const HireAndAnalyzeContainer: FC = () => {
  const { t } = useTranslation()

  return (
    <LayoutLandingPage>
      <HeroBanner
        badgeLabel={t('hire_n_analyze:label')}
        badgeColor="bg-purple-100 text-purple-800"
        title={t('hire_n_analyze:title')}
        description={t('hire_n_analyze:description')}
        images={{
          desktop: '/img/feature/lp/hire-and-analyze-hero-desk.png',
          mobile: '/img/feature/lp/hire-and-analyze-hero-mweb.png'
        }}
        imageClassName="tablet:w-[55%]"
      />

      {/* Feature 1 */}
      <LazyLoadWrapper height={500} once>
        <FeatureBlock
          className="mt-[64px] mb-0 desktop:mt-[140px] desktop:mb-0"
          title={t('hire_n_analyze:simple_offer_process')}
          description={t('hire_n_analyze:simple_offer_process_description')}
          textPosition="right"
          openLink={<ContactRequestButton />}
          image={
            <picture>
              <source
                media="(min-width: 768px)"
                srcSet="/img/feature/lp/hire-and-analyze-feature-1-desk.png"
              />
              <source
                media="(max-width: 767px)"
                srcSet="/img/feature/lp/hire-and-analyze-feature-1-mweb.png"
              />
              <img alt="Simplify offer management processes" loading="lazy" />
            </picture>
          }
        />
      </LazyLoadWrapper>

      {/* Feature 2 */}
      <LazyLoadWrapper height={500} once>
        <FeatureBlock
          className="mt-[64px] mb-0 desktop:mt-[140px] desktop:mb-0"
          title={t('hire_n_analyze:better_data')}
          description={t('hire_n_analyze:better_data_description')}
          textPosition="top"
          openLink={<ContactRequestButton />}
          image={
            <div className="flex flex-col tablet:flex-row gap-4 tablet:gap-5">
              <img
                src="/img/feature/lp/hire-and-analyze-feature-2.1.png"
                alt="Better data, better decision"
                className="w-full tablet:w-[calc(60%_-_10px)]"
                loading="lazy"
              />
              <img
                src="/img/feature/lp/hire-and-analyze-feature-2.2.png"
                alt="Better data, better decision"
                className="w-full tablet:w-[calc(40%_-_10px)]"
                loading="lazy"
              />
            </div>
          }
        />
      </LazyLoadWrapper>

      <LazyLoadWrapper height={500} once>
        <TeamSection />
      </LazyLoadWrapper>

      <LazyLoadWrapper height={500} once>
        <JourneySection className="desktop:mt-[140px] desktop:mb-[0px] bg-gray-50 mt-[64px] my-[0px] py-[64px]" />
      </LazyLoadWrapper>
    </LayoutLandingPage>
  )
}

export default HireAndAnalyzeContainer
